var _BaseGateway_instances, _BaseGateway_configureCache;
import { __classPrivateFieldGet } from "tslib";
import { CacheManager } from '@descomplica/caching-browser';
export class BaseGateway {
    constructor() {
        _BaseGateway_instances.add(this);
        __classPrivateFieldGet(this, _BaseGateway_instances, "m", _BaseGateway_configureCache).call(this);
    }
}
_BaseGateway_instances = new WeakSet(), _BaseGateway_configureCache = function _BaseGateway_configureCache() {
    this.cache = CacheManager.getCache(this.getCacheType(), this.getCacheNamespace());
};
